import {makeAutoObservable} from "mobx";
import axios from "axios";
import AuthService from "../service/AuthService";

export default class UserStore {
    isAuth = false
    user = {}
    token = {}
    isLoading = false
    role = [
        {id: 'ADMIN', value: 'Администратор'},
        {id: 'SUPERVISOR', value: 'Руководитель'},
        {id: 'USER', value: 'Пользователь'}
    ]
    constructor() {
        makeAutoObservable(this)
    }

    setIsAuth(bool) {
        this.isAuth = bool
    }

    setUser(user) {
        this.user = user
    }

    setToken(token) {
        this.token = token
    }

    setIsLoading(bool) {
        this.isLoading = bool
    }

    async login(nickname, password, setActive) {
        try {
            const {data} = await AuthService.login(nickname, password)
            localStorage.setItem('token', data.accessToken)
            this.setIsAuth(true)
            this.setUser(data.user)
            this.setToken(data.refreshToken)
        } catch (e) {
            setActive(true)
        }
    }

    async registr(nickname, password, firstName, secondName, role, setActive) {
        try {
            const {data} = await AuthService.registration(nickname, password, firstName, secondName, role)
            localStorage.setItem('token', data.accessToken)
            this.setIsAuth(true)
            this.setUser(data.user)
            this.setToken(data.refreshToken)
        } catch (e) {
            setActive(true)
        }
    }

    async addOneUser(nickname, password, firstName, secondName, role, setErrLogin) {
        try {
            const {data} = await AuthService.addUser(nickname, password, firstName, secondName, role)
            this.setIsAuth(true)
            this.setUser(data.user)
        } catch (e) {
            setErrLogin(true)
        }
    }

    async logout() {
        try {
            const response = await AuthService.logout()
            localStorage.removeItem('token')
            this.setIsAuth(false)
            this.setUser({})
            this.setToken({})
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

    async checkAuth() {
        this.setIsLoading(true)
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}api/user/refresh`, {withCredentials: true})
            localStorage.setItem('token', response.data.accessToken)
            this.setIsAuth(true)
            this.setUser(response.data.user)
            this.setToken(response.data.refreshToken)
        } catch (e) {

        } finally {
            this.setIsLoading(false)
        }
    }
}